// TH has custom logic for MainHero
// other brands should always display if the feature component is in Sanity
export const useShouldShowHero = () => true;
